module.exports = __webpack_public_path__ + "img/emoji_45.829b8e4c.png";